import { render } from "./PaymentMethods.vue?vue&type=template&id=c2df9cb8&ts=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__